export default __webpack_public_path__ + "static/media/flights.0387f58a.webp";